/*
 * @Author: wuxh
 * @Date: 2021-08-02 18:47:50
 * @LastEditTime: 2021-08-03 10:22:50
 * @LastEditors: wuxh
 * @Description:
 * @FilePath: /stpass-antd/components/button-plus/index.tsx
 */
/* eslint-disable react/prefer-stateless-function */
import * as React from 'react';
// import { Button, Popconfirm } from '../../button';
import Button from '../button';
import Popconfirm from '../popconfirm';
export default class ButtonPlus extends React.Component {
    render() {
        const { type, onClick } = this.props;
        if (type === 'del') {
            return (<Popconfirm title="确认要删除吗?" onConfirm={onClick} style={{ width: 200 }}>
          <Button {...this.props} type="default" onClick={(e) => e.preventDefault()}>
            删除
          </Button>
        </Popconfirm>);
        }
        return <Button {...this.props}/>;
    }
}
